/* eslint-disable max-len */
export default {
  title: "Verification",
  phoneSendCode: {
    description: "If you want to gain <span>bonus {receiverBonusAmount} zł</span> <b>enter your phone number</b>",
    placeholder: "Enter your phone number",
    nextButtonText: "Send code",
    genericError: "Enter a valid phone number",
  },
  phoneSmsConfirmation: {
    description: "Enter the received <b>SMS code</b>",
    details: "We have sent the code to the {phoneNumber} number",
    placeholder: "Enter SMS code",
    prevButtonText: "Correct the number",
    nextButtonText: "Confirm",
    resendSmsText: "SMS didn't come?",
    resendSmsButtonText: "Resend the SMS code",
    genericError: "The entered SMS code is incorrect",
  },
  phoneVerificationSuccess: {
    title: "Recommend and <b>earn</b>",
    description: "Verification was successful",
    details: "Your bonus is a on your goodie cashback account as a pending transaction. We will approve it when you <b>make your first purchase through goodie cashback.</b>",
    nextButtonText: "I'm starting shopping!",
  },
  whatIsCashback: {
    title: "What is <b>cashback</b>",
    subTitle: "When you shop in online stores, <b>you can get some money back</b> - that's cashback. In goodie you will find almost 600 well-known online stores where you can get cashback.",
    step1Title: "Open goodie",
    step1Description: "Register in goodie cashback on goodie.pl or in goodie mobile app.",
    step2Title: "Select store and shop",
    step2Description: "Select store in goodie and press 'Go to the shop' button. Choose products and make payment - the same way you always do!",
    step3Title: "Get cashback",
    step3Description: "You will find cashback amount on your goodie user account. After transaction is confirmed by the store, your cashback will be accepted.",
    step4Title: "Receive cash to your bank account",
    step4Description: "After collecting at least 21 zł of cashback you can transfer it to your account in any bank.",
    videoTitle: "Watch the video",
  },
};
